import { formConfig } from 'config/forms';
import { DEFAULT_LATEST, THIS_MONTH } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { getSafeDateTime, isSafeDateLater, setToStartOfMonth } from 'helpers/date';
import { SafeDateTime } from 'helpers/types';
import { isPVQForm } from 'helpers/form';
import { SubstanceThcPublicSafetyItemModel } from '../types';

const substanceThcPublicSafetyItemValidator: ValidateJSModel<SubstanceThcPublicSafetyItemModel> = {
  Description: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    return { presence: true, hasValue: true };
  },
  
  InvolvementDates: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      const formTypeConfig = options?.formType && formConfig[options?.formType as keyof typeof formConfig];
      const years: any = formTypeConfig && formTypeConfig.SUBSTANCE_DRUG_PUBLIC_SAFETY_YEARS;

      const beyondRequired: SafeDateTime = getSafeDateTime(THIS_MONTH);
      let useDuration = false;

      if (years && beyondRequired?.valid && typeof years === 'number') {
        beyondRequired.datetime = beyondRequired.datetime.minus({ years });
        useDuration = !value?.present && isSafeDateLater(beyondRequired, setToStartOfMonth(getSafeDateTime(value?.to)));
      }

      return {
        presence: true,
        daterange: {
          requireDay: false,
          earliest: useDuration ? setToStartOfMonth(beyondRequired).datetime : setToStartOfMonth(options?.applicantBirthdate),
          tooEarly: useDuration ? 'error.beforeDuration' : 'error.applicantMin',
          latest: DEFAULT_LATEST
        },
      };
    }
    const formTypeConfig = options?.formType && formConfig[options?.formType as keyof typeof formConfig];
    const years: any = formTypeConfig && formTypeConfig.SUBSTANCE_DRUG_PUBLIC_SAFETY_YEARS;

    const beyondRequired: SafeDateTime = getSafeDateTime(THIS_MONTH);
    let useDuration = false;

    if (years && beyondRequired?.valid && typeof years === 'number') {
      beyondRequired.datetime = beyondRequired.datetime.minus({ years });
      useDuration = !value?.present && isSafeDateLater(beyondRequired, setToStartOfMonth(getSafeDateTime(value?.to)));
    }

    return {
      presence: true,
      daterange: {
        requireYear: false,
        earliest: useDuration ? setToStartOfMonth(beyondRequired).datetime : setToStartOfMonth(options?.applicantBirthdate),
        tooEarly: useDuration ? 'error.beforeDuration' : 'error.applicantMin',
        latest: DEFAULT_LATEST
      },
    };
  },
  // field used in sf and pvq forms
  EstimatedUse: (value, attributes, attributeName, options) => ({ presence: true, hasValue: true }),
  Comments: {},
  UseWhileEmployedPosition: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  UseWhileEmployedPositionOther: {}, // not used in pvq or sf form
  HowManyTimes: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  Reason: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },

};

export default substanceThcPublicSafetyItemValidator;
